<template>
  <div class="ui small modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="cube icon"></i>
      {{ $t("module setup") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/module_1.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <form-wizard
          title=""
          subtitle=""
          :nextButtonText="$t('next')"
          :backButtonText="$t('back')"
          :finishButtonText="$t('finish')"
          shape="circle"
          @on-complete="onComplete"
        >
          <tab-content
            icon="info icon"
            :title="$t('general')"
            :before-change="validate_general"
            ><general ref="general"
          /></tab-content>
          <tab-content
            icon="tools icon"
            :title="$t('initilization')"
            :before-change="validate_initialization"
            ><initialization ref="initialization"
          /></tab-content>
        </form-wizard>
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <!-- <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { error_toast } from "@/utils";
import { FormWizard, TabContent } from "vue-form-wizard";
import General from "./General";
import Initialization from "./Initialization";

export default {
  name: "SettingsModuleModalIndex",
  components: { FormWizard, TabContent, General, Initialization },
  props: {},
  computed: {},
  data() {
    return {};
  },
  methods: {
    show_modal() {
      let vm = this;

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
          onHidden() {
            vm.$refs.general.reset_form();
          },
        })
        .modal("show");

      vm.$refs.general.init_form();
    },
    validate_general: function() {
      let vm = this;
      return new Promise((resolve, reject) => {
        let isValid = vm.$refs.general.is_valid();
        if (isValid) {
          vm.$refs.general
            .create_module()
            .then((rmodule) => {
              console.log("rmodule ", rmodule);
              resolve(true);
            })
            .catch((err) => {
              error_toast(err);
              reject(err);
            });
        } else reject();
      });
    },
    validate_initialization: function() {
      return new Promise((resolve /* reject */) => {
        resolve(true);
        console.log("here should validate initialization tab");
      });
    },
    onComplete: function() {
      console.log("this shit is completed");
      // let vm = this;
      // let uuid = vm.$route.query.u;
      // local_api(vm, "post", "/feedback_360/survey/do-respond", {
      //   u: uuid,
      //   r: vm.responses,
      // })
      //   .then(() => {
      //     window.jQuery(vm.$refs.sides).shape("flip back");
      //     vm.show_responses = false;
      //   })
      //   .catch((err) => {
      //     error_toast(err);
      //   });
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
